// removed by extract-text-webpack-plugin
module.exports = {"root":"style__root___3IZdN","label":"style__label___3qaE9","message":"style__message___1j-hO","error":"style__error___1mUtA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/InputForm/style.scss
// module id = 1387
// module chunks = 0